import { createContext } from "react";

import type { TrailingOverrideContextValue } from "./types";

export const TrailingOverrideContext =
  createContext<TrailingOverrideContextValue | null>(null);
TrailingOverrideContext.displayName = "TrailingOverrideContext";
